import { ChevronDown, Clock, Mic, Phone, RefreshCw, Sparkles } from "lucide-react";
import { useState } from "react";
import { DateField } from "@/components/DateField";

const STATUS = { answered: "décroché", no_answer: "non décroché", missed: "manqué", voicemail: "messagerie" };

const CallInfo = ({ d }) => (
  <div className="db-meta" data-testid="debrief-call-info">
    <span><Phone size={13} /> {d.call ? `${STATUS[d.call.status] || "appel"} · ${Math.round((d.call.duration || 0) / 6) / 10} min` : "appel Ringover non retrouvé"}</span>
    {d.tag && <span className="db-tag">{d.tag}</span>}
    {d.lead?.step && <span>{d.lead.pipeline} › {d.lead.step}</span>}
    {d.voice_note && <span className="db-voice"><Mic size={13} /> « {d.voice_note} »</span>}
  </div>
);

const Answer = ({ a, onChange, i }) => (
  <label className="db-answer">{a.question}
    {a.options?.length ? (
      <select value={a.answer} onChange={(e) => onChange(e.target.value)} data-testid={`debrief-answer-${i}`}><option value="">—</option>{a.options.map((o) => <option key={o} value={o}>{o}</option>)}{a.answer && !a.options.includes(a.answer) && <option value={a.answer}>{a.answer}</option>}</select>
    ) : <input value={a.answer} onChange={(e) => onChange(e.target.value)} data-testid={`debrief-answer-${i}`} />}
  </label>
);

// Carte de débrief : champs pré-remplis par l'IA, tous modifiables
export const DebriefCard = ({ d, form, setForm, editing, onPrefill, refilling }) => {
  const [transcript, setTranscript] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  if (d.status === "waiting") {
    return (
      <div className="db-waiting" data-testid="debrief-waiting">
        <Clock size={22} /><strong>En attente de la transcription Ringover</strong>
        <p>L'IA pré-remplira cette fiche dès que la transcription arrive (quelques minutes en général).</p>
        <button type="button" className="secondary-button" disabled={refilling} onClick={onPrefill} data-testid="debrief-prefill-now"><Sparkles size={14} /> {refilling ? "Analyse…" : "Pré-remplir maintenant"}</button>
      </div>
    );
  }
  return (
    <div className={`db-fields${editing ? " editing" : ""}`}>
      <CallInfo d={d} />
      {d.ai_error && <p className="pl-warning" data-testid="debrief-ai-error">{d.ai_error} <button type="button" className="pl-link" onClick={onPrefill}><RefreshCw size={12} /> Relancer</button></p>}
      <label>Résumé de l'appel<textarea rows={3} value={form.summary} onChange={set("summary")} data-testid="debrief-summary" /></label>
      <label>Commentaire enregistré sur la fiche<textarea rows={3} value={form.comment} onChange={set("comment")} data-testid="debrief-comment" /></label>
      {form.script_answers.length > 0 && (
        <fieldset className="db-script" data-testid="debrief-script"><legend>Réponses au script</legend>
          {form.script_answers.map((a, i) => <Answer key={a.question} a={a} i={i} onChange={(v) => setForm({ ...form, script_answers: form.script_answers.map((x, k) => (k === i ? { ...x, answer: v } : x)) })} />)}
        </fieldset>
      )}
      <div className="db-next">
        <label>Prochaine action<input value={form.next_action} onChange={set("next_action")} data-testid="debrief-next-action" /></label>
        <label>Date<DateField value={form.next_date} onChange={(v) => set("next_date")({ target: { value: v } })} testid="debrief-next-date" /></label>
      </div>
      {d.call?.transcript_status === "ok" && d.transcript && <button type="button" className="pl-link" onClick={() => setTranscript(!transcript)}><ChevronDown size={13} /> Transcription</button>}
      {transcript && <pre className="db-transcript">{d.transcript}</pre>}
    </div>
  );
};
